<template lang="html">
  <div class="fadeIn user-wrapper">
    <h2 v-if="isCourseType" ><b>{{ $t('holes.create') }}</b></h2>
    <h2 v-else ><b>{{ $t('zones.create') }}</b></h2>
    <div class="row m-0">
      <div class="col-sm-12 col-md-5 form-container card">
        <form @submit="onSubmit($event)">
        <div class="form-group">
          <label v-if="isCourseType" for="hole" style="color: gray">{{ $t('holes.number') }}</label>
          <label v-else for="hole" style="color: gray">{{ $t('zones.number') }}</label>
          <input type="Number" v-model="form.holeNumber" required class="form-control" id="hole" style="width: 150px;">
          <br><br>
        </div>
        <button type="submit" class="btn btn-primary large f-right" :disabled="loading">
          <span class="spinner-border spinner-border-sm"
          v-show="loading"/>
          {{ $t('general.save') }}
        </button>
        <router-link to="/holes"
          class="btn btn-secondary large f-right m-rigth-15">
          {{ $t('general.cancel') }}
        </router-link>
      </form>
      </div>
      
    </div>
  </div>
</template>

<script>
import { saveHole, updateHole, getHole } from '@/api/index';
import {
    mapState,
  } from 'vuex';

export default {
  name: 'HoleOperations',
  data() {
    return {
      title: '',
      form: {
        holeNumber: null,
      },
      holeId: this.$router.currentRoute.params.id,
      loading: false,
    };
  },
  computed: {
    ...mapState(['course']),
    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
        || !this.course.facility_type){
          return true;
      }else{
        return false;
      }
    }
  },
  methods: {
    callback(res) {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Holes New");
        this.$analytics.logEvent("web_holes_new");
      }
      this.$router.push('/holes');
      this.loading = false;
    },
    onSubmit(e) {
      e.preventDefault();
      this.loading = true;
      if (this.$router.currentRoute.name === 'UpdateHole') {
        updateHole({ hole_number: this.form.holeNumber }, this.holeId)
          .then(this.callback)
          .catch(() => {
            this.loading = false;
          });
      } else {
        saveHole({ hole_number: this.form.holeNumber, course_id: this.$store.state.course.course_id })
          .then(this.callback)
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    if (this.$router.currentRoute.name === 'UpdateHole') {
      this.title = this.$t('general.update');
    } else {
      this.title = this.$t('general.create');
    }

    if (this.holeId) {
      getHole(this.holeId).then((res) => {
        this.form.holeNumber = res.hole_number;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.container-fluid{
  height: 100% !important;
}
.user-wrapper{
  display: flex;
  flex-direction: column;
  // height: 100% !important;
  // align-items: center;
  justify-content: center;
  width: 100%;
  .form-container{
    background: white;
    padding: 2rem;
    
    justify-content: space-around;
    
  }
}
</style>
